import styled from 'styled-components';
import Container from './Common/Container';
import BannerImg from '../Assets/Group 136.png';
import MainForm from './MainFrom';

const BannerWrapper = styled.div`
    height: calc(100vh - 61px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 ${(props) => props.theme.padding.unMatch};
    @media (max-width: 1440px) {
        padding: 0 40px;
    }
`;

const BannerLeftContainer = styled.div`
    width: 30%;
    @media (max-width: 1440px) {
        width: 35%;
    }
`;

const BannerRightContainer = styled.div`
    width: 65%;
    display: flex;
    justify-content: center;
    @media (max-width: 1440px) {
        width: 60%;
    }
`;

const BannerHeading = styled.h1`
    font-size: 42px;
    font-weight: ${(props) => props.theme.font.weight.default};
    line-height: 48px;
    margin: 0 0 25px 0;
    @media (max-width: 1440px) {
        font-size: 36px;
        font-weight: ${(props) => props.theme.font.weight.default};
        line-height: 42px;
    }
`;

const BannerCaption = styled.p`
    font-size: 17px;
    font-weight: ${(props) => props.theme.font.weight.default};
    line-height: 22px;
    margin: 0 0 25px 0;
    color: ${(props) => props.theme.colors.offWhite};
    @media (max-width: 1440px) {
        font-size: 16px;
        font-weight: ${(props) => props.theme.font.weight.default};
        line-height: 22px;
    }
`;

const Break = styled.div`
    height: 1px;
    width: 100%;
    background: ${(props) => props.theme.border.default};
    margin: 35px 0 0 0;
`;

const BannerImgPlaceholder = styled.img`
    width: 100%;
`;

const MainBanner = () => {
    return (
       <Container>
            <BannerWrapper>
                <BannerLeftContainer>
                    <BannerHeading>
                        মাতৃভাষায় যোগাযোগের মাধ্যম
                        <br/>
                        এখন সবার জন্য ফ্রী
                    </BannerHeading>
                    <BannerCaption>
                        সহজতর বাংলা ভাষায় একটি যোগাযোগের মাধ্যম তৈরি করায় আমাদের মূল উদেশ্য, যাতে বিজনেস থেকে সাধারন মানুষ সকেলে তাদের যোগাযোগের জন্য আমাদের প্ল্যাটফর্ম ব্যাবহার করতে পারনে।
                    </BannerCaption>
                    <MainForm/>
                    <Break/>
                </BannerLeftContainer>
                <BannerRightContainer>
                    <BannerImgPlaceholder src={BannerImg} alt="Banner"/>
                </BannerRightContainer>
            </BannerWrapper>
       </Container>
    )
}

export default MainBanner;